import { useCallback } from 'react';
import { useUrlCtaAction } from '../../../../components/Notifications/hooks/useUrlCtaAction';
import type { EmitPageEventCta, UrlCta } from '../../../../components/Notifications/types';
import type { PageCta } from '../types';
import { useEmitPageEventCtaAction } from './useEmitPageEventCtaAction';
import { usePageCtaAction } from './usePageCtaAction';

type Params = {
  cta: PageCta | EmitPageEventCta | UrlCta;
};

export const useNotificationCtaActions = () => {
  const onPageCtaClick = usePageCtaAction();
  const onEmitPageEventCtaClick = useEmitPageEventCtaAction();
  const onUrlCtaClick = useUrlCtaAction();

  const getCtaActions = useCallback(
    ({ cta }: Params) => {
      if (cta.type === 'page') {
        return onPageCtaClick({ cta });
      } else if (cta.type === 'emitPageEvent') {
        return onEmitPageEventCtaClick({ cta });
      } else if (cta.type === 'url') {
        return onUrlCtaClick({ cta });
      }

      return undefined;
    },
    [onPageCtaClick, onEmitPageEventCtaClick, onUrlCtaClick],
  );

  return getCtaActions;
};
